import { gql } from "@apollo/client";

export const inquiryFormsList = gql`
  query InquiryFormsList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $sort: PageSortingInput
    $filter: PageFilterInput
  ) {
    pages(
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
      filter: $filter
    ) {
      edges {
        node {
          id
          title
          slug
          pageType {
            id
            name
            slug
          }
          metadata {
            key
            value
          }
          isPublished
          created
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

export const pageTypesQuery = gql`
  query InquiryFormPageTypes($filter: PageTypeFilterInput, $first: Int) {
    pageTypes(filter: $filter, first: $first) {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
  }
`;

export const inquiryFormDetails = gql`
  query InquiryFormDetails($id: ID!) {
    page(id: $id) {
      id
      title
      slug
      pageType {
        id
        name
        slug
      }
      metadata {
        key
        value
      }
      isPublished
      created
    }
  }
`;